import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faSyncAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons'



import { supabase } from '../../api'

export const CategoryForm = ({ defaultCategory, handleSave, canDelete, handleDelete }) => {


    const [category, setCategory] = useState(defaultCategory || {});
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const doSave = async () => {
        setSaving(true)

        console.log('upsert', category)
        const { data, error } = await supabase
            .from('categories')
            .upsert(category)
            .select()
            .single()
        if (error) {
            console.error('error upserting', error)
        }

        setSaving(false)
        if (data) handleSave(data)
    }

    const doDelete = async () => {

        if (!canDelete) return

        setDeleting(true)

        const { error } = await supabase
            .from('categories')
            .delete()
            .match({ id: category.id })

        if (error) {
            console.error(error)
            return
        }

        handleDelete(category.id)

    }

    return (
        <>
            <table style={{ width: 500 }}>
                <tbody>
                    <tr>
                        <td>Name</td>
                        <td><input name='name' style={{ width: 280 }} placeholder='name' defaultValue={category.name} onChange={e => setCategory({ ...category, name: e.target.value })} /></td>
                    </tr>
                    <tr>
                        <td>Position</td>
                        <td><input name='position' placeholder='position' style={{ width: 80 }} defaultValue={category.position} onChange={e => setCategory({ ...category, position: parseInt(e.target.value) })} />
                        </td>
                    </tr>
                </tbody>
            </table>

            <div className='space-between'>

                {canDelete ? <button className='inv' onClick={doDelete}>
                    <FontAwesomeIcon spin={deleting} icon={deleting ? faSyncAlt : faTrashAlt} />&nbsp;
                    Delete
                </button> : <span></span>}


                <button className='clear' onClick={doSave}>
                    <FontAwesomeIcon spin={saving} icon={saving ? faSyncAlt : faSave} />&nbsp;
                    Save
                </button>
            </div>
        </>
    )
}

export default CategoryForm;